import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { identityQuery } from '@/features/auth/auth.queries'
import { AppShell } from '@/app/AppShell'

export const Route = createFileRoute('/_authed')({
  /*
   * The gate for every authenticated page.
   *
   * In `beforeLoad`, not a `useEffect`: an effect runs after the first paint, which flashes the
   * sidebar and whatever the page renders empty before bouncing to the login screen. This never
   * renders anything.
   *
   * It is a courtesy gate, not a security one — every request behind it is authorized again on
   * the server. Someone who forces their way past this sees an empty shell and a wall of 403s.
   */
  beforeLoad: async ({ context, location }) => {
    try {
      // `query` with a static staleTime replaces the deprecated `ensureQueryData`: use the
      // cached identity when there is one, fetch when there is not, never refetch here.
      const identity = await context.queryClient.query({ ...identityQuery, staleTime: 'static' })

      return { identity }
    } catch {
      throw redirect({ to: '/login', search: { redirect: location.href } })
    }
  },
  component: AuthedLayout,
})

function AuthedLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}
